// src/features/bookings/components/BookingList/BookingSortBar.jsx
import React from 'react';
import styles from './BookingSortBar.module.css';

const SORT_OPTIONS = [
  { key: 'booking_date', direction: 'desc', label: 'الأحدث أولاً' },
  { key: 'booking_date', direction: 'asc',  label: 'الأقدم أولاً' },
  { key: 'client',       direction: 'asc',  label: 'فرز أبجدي' },
];

const BookingSortBar = ({ sortConfig, onSort }) => {
  const isActive = (key, direction) =>
    sortConfig.key === key && sortConfig.direction === direction;

  return (
    <div className={styles.bar}>
      <span className={styles.label}>الترتيب:</span>
      {SORT_OPTIONS.map((opt) => (
        <button
          key={`${opt.key}-${opt.direction}`}
          type="button"
          className={`${styles.btn} ${isActive(opt.key, opt.direction) ? styles.active : ''}`}
          onClick={() => onSort(opt.key, opt.direction)}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
};

export default BookingSortBar;